import { render, staticRenderFns } from "./LocationWorkerType.vue?vue&type=template&id=d80af1e2&"
import script from "./LocationWorkerType.vue?vue&type=script&lang=ts&"
export * from "./LocationWorkerType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports